var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7789 69.0761L43.7168 20.9326C44.5392 19.5644 45.7841 18.675 47.1558 18.2643C49.7044 17.5012 52.6909 18.3906 54.2188 20.9326L83.1567 69.0761C85.5322 73.0281 82.6067 78 77.9057 78H19.9757C15.2776 77.9966 12.4042 73.0268 14.7789 69.0761Z",
    fill: "#F3F3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9669 69.0761C10.4881 72.7993 12.9669 78 18.2179 78L19.9757 78C15.2776 77.9966 12.4042 73.0268 14.7789 69.0761L43.7168 20.9326C44.5392 19.5644 45.7841 18.675 47.1558 18.2643C45.7841 18.675 44.7398 19.1765 43.5318 20.9326C43.5318 20.9326 15.4457 65.3529 12.9669 69.0761Z",
    fill: "#1A0826"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9757 78H77.9057C82.6067 78 85.5322 73.0281 83.1567 69.0761L54.2188 20.9326C52.6909 18.3906 49.7044 17.5012 47.1558 18.2643M19.9757 78C15.2776 77.9966 12.4042 73.0268 14.7789 69.0761L43.7168 20.9326C44.5392 19.5644 45.7841 18.675 47.1558 18.2643M19.9757 78L18.2179 78C12.9669 78 10.4881 72.7993 12.9669 69.0761C15.4457 65.3529 43.5318 20.9326 43.5318 20.9326C44.7398 19.1765 45.7841 18.675 47.1558 18.2643",
    stroke: "#1A0826",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4 36.6001H43.2L46.28 56.6776H53.4717L56.4 36.6001Z",
    fill: "#AA8FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 36.6001H42L45.08 56.6776H46.28L43.2 36.6001Z",
    fill: "#1A0826"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7099 65.9452C55.7099 61.966 53.988 60.6147 49.9184 60.4987C45.9233 60.6147 44.1604 61.966 44.1604 65.9452C44.1604 69.8512 45.8123 71.2781 49.9462 71.3925C54.3923 71.2816 55.7099 69.9332 55.7099 65.9452Z",
    fill: "#AA8FFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9604 65.9452C42.9604 70.0249 44.7625 71.4001 49.3126 71.4001C49.5306 71.4001 49.7417 71.3976 49.9462 71.3925C45.8123 71.2781 44.1604 69.8512 44.1604 65.9452C44.1604 61.966 45.9233 60.6147 49.9184 60.4987C49.722 60.4931 49.5201 60.4904 49.3126 60.4904C44.8976 60.4904 42.9604 61.7739 42.9604 65.9452Z",
    fill: "#1A0826"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 36.6001H42L45.08 56.6776H46.28M43.2 36.6001L46.28 56.6776M43.2 36.6001H56.4L53.4717 56.6776H46.28M49.9184 60.4987C49.722 60.4931 49.5201 60.4904 49.3126 60.4904C44.8976 60.4904 42.9604 61.7739 42.9604 65.9452C42.9604 70.0249 44.7625 71.4001 49.3126 71.4001C49.5306 71.4001 49.7417 71.3976 49.9462 71.3925M49.9184 60.4987C45.9233 60.6147 44.1604 61.966 44.1604 65.9452C44.1604 69.8512 45.8123 71.2781 49.9462 71.3925M49.9184 60.4987C53.988 60.6147 55.7099 61.966 55.7099 65.9452C55.7099 69.9332 54.3923 71.2816 49.9462 71.3925",
    stroke: "#1A0826",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.2d77c362b18a922a9ea95954fd4b1dcd.svg";
export { ForwardRef as ReactComponent };